<p style="padding-left: 32px; font-size: 18px;">Stai per aprire una chat WhatsApp col numero: {{phone}}</p>
